import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../dispatch'
import { useNavigate } from 'react-router-dom'
import { setShowSelectionOnlyRange } from '../slice/showSelectionOnlySlice'
import mittEmitter from '../utils/mitt'

const useOnReferenceSelected = () => {
  const references = useAppSelector((state) => state.references.references)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handler = (bindingId: string) => {
      const item = references.find((ref) => ref.bindingId === bindingId)
      if (item) {
        if (item.bindingGroupId) {
          dispatch(
            setShowSelectionOnlyRange({
              rangeAddress: item.rangeAddr,
              sheetId: item.sheetId,
            })
          )
          mittEmitter.emit(
            'SHOW_DUPLICATE_FINDINGS_POP_UP',
            item.bindingGroupId
          )
        } else {
          dispatch(
            setShowSelectionOnlyRange({
              rangeAddress: item.rangeAddr,
              sheetId: item.sheetId,
            })
          )
          navigate(`/file/${item.fileId}`, {
            state: { page: item.filePage, top: item.top ?? 0 },
          })
        }
      }
    }

    // AppCustomEvent.ON_REFERENCE_SELECTED
    mittEmitter.on('ON_REFERENCE_SELECTED', handler)

    return () => {
      mittEmitter.off('ON_REFERENCE_SELECTED', handler)
    }
  }, [references, navigate, dispatch])
}

export default useOnReferenceSelected
